import { defaultSelectedLicencia } from "./state";

export function setListarLicencia(state, licencias) {
    state.licencias = licencias
}

export function setListarLicenciasEmpresas(state, licencias) {
    state.licenciaEmpresas = licencias
}

export function setLicencia(state, licencia) {
    state.selectedLicencia = licencia;
}

export function setAction(state, action) {
    state.action = action;
}

export function setPage(state, page) {
    state.filtro.page = page
}

export function licenciaError(state, payload) {
    state.error = true
    state.errorMessage = payload
    state.licencias = []
}

export function setGetLicenciaEdit(state, getLicenciaEdit) {
    state.getLicenciaEdit = getLicenciaEdit;
}

//
export function setFiltro(state, buscar) {
    state.filtro = buscar
}
//
export function setFiltroEmpresa(state, buscar) {
    state.filtroEmpresa.empresa = buscar
}

export function resetSelectedLicencia(state) {
    Object.assign(state.selectedLicencia, defaultSelectedLicencia())
}